import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import AccountInfo from "../../components/AccountInfo";
import ChangePassword from "../../components/ChangePassword";
import InvoiceTable from "../../components/InvoiceTable";
import FilterSelect from "../../components/FilterDropdown";


const AccountPage = () => {
    const [key, setKey] = useState("accountInfo");
    const handleFilterChange = (value) => {
        console.log("Selected Filter:", value);
        // Implement filter logic here (e.g., fetch data based on selection)
    };
    return (
        <div className="account-container">
            <h2 className="mb-20">Account</h2>
            <div className="account-element v-tab">
                <Tabs
                    id="account-tabs"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3 account-tabs"
                >
                    {/* Account Info Tab */}
                    <Tab eventKey="accountInfo" title="My Account Info">
                        <div className="account-info-container">
                            <h3>Account Information</h3>
                            <AccountInfo/>
                        </div>
                    </Tab>

                    {/* Change Password Tab */}
                    <Tab eventKey="changePassword" title="Change Password">
                        <div className="account-info-container">
                            <h3>Change Password</h3>
                            <ChangePassword/>
                        </div>
                    </Tab>

                    {/* Purchase History Tab */}
                    <Tab eventKey="purchaseHistory" title="Purchase History">
                        <div className="account-info-container">
                            <h3>
                                Purchase History
                                <FilterSelect onFilterChange={handleFilterChange} />
                            </h3>
                            <InvoiceTable/>
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </div>
    );
};

export default AccountPage;
